/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель списка причин отмены заявки СП
   */
  app.CancellationReasons = app.Model.extend({

    PARTICIPANT: 'participant',
    ORGANIZER: 'organizer',

    urlRoot: app.entryScriptName + '/api/v3/jp-cancellation-reason',

    run: function (options) {
      if (options){
        if (options.type === this.PARTICIPANT){
          this.expand = 'type=1,3';
        }
        if (options.type === this.ORGANIZER){
          this.expand = 'type=2,3';
        }
      }
    }
  });
})();

}.call(window));